import React from "react";
import { viewOptionSelector } from "~redux/slices/viewOptionSlice";
import { useRootDispatch, useRootSelector } from "~redux/hooks";
import { View } from "components/utils/View";
import { ViewOptionContextProvider } from "contexts/viewOptionContext";
import { CpdlcMsgOut as BaseCpdlcMsgOut, cpdlcTocHeldView } from "@poscon/shared-frontend";
import { setAsel } from "~/redux/slices/edstSlice";

const view = "CPDLC_MSGOUT";

export const CpdlcMsgOut = () => {
  const dispatch = useRootDispatch();
  const viewOptions = useRootSelector((state) => viewOptionSelector(state, view));

  return (
    <ViewOptionContextProvider options={viewOptions}>
      <BaseCpdlcMsgOut
        ViewComponent={View}
        openTocMenu={(fpId) => dispatch(setAsel({ fpId, menu: cpdlcTocHeldView, field: null }))}
      />
    </ViewOptionContextProvider>
  );
};
